import DemoPageWrapper from "../../utils/DemoPageWrapper";
import Demo from "./demo";
import DemoSource from "!!raw-loader!./demo.vue";
const config = {
  props: [
    {
      prop: "value",
      description: "当前选中值"
    },
    {
      prop: "options",
      description: "下拉选项",
      type: "Array"
    },
    {
      prop: "multiple",
      description: "多选",
      type: "Boolean",
      default: "false"
    },
    {
      prop: "showIcon",
      description: "展示图标",
      type: "Boolean",
      default: "false"
    },
    {
      prop: "filterable",
      description: "过滤",
      type: "Boolean",
      default: "false"
    },
    {
      prop: "filterClearable",
      description: "过滤输入框可清除",
      type: "Boolean",
      default: "true"
    },
    {
      prop: "filterMethod",
      description: "自定义过滤函数",
      type: "Function"
    },
    {
      prop: "async",
      description: "异步请求过滤",
      type: "Boolean",
      default: "false"
    },
    {
      prop: "loading",
      description: "请求loading",
      type: "Boolean",
      default: "false"
    },
    {
      prop: "clearable",
      description: "可清除",
      type: "Boolean",
      default: "false"
    },
    {
      prop: "border",
      description: "同input的border",
      type: "Boolean",
      default: "true"
    },
    {
      prop: "placeholder",
      description: "同input的placeholder",
      type: "String"
    },
    {
      prop: "maxHeight",
      description: "下拉最大高度",
      type: "Number",
      default: "260"
    },
    {
      prop: "dropdownWidth",
      description: "下拉宽度",
      type: "Number",
      default: "220"
    },
    {
      prop: "dropdownWidthAuto",
      description: "下拉宽度自动同步input",
      type: "Boolean",
      default: "true"
    },
    {
      prop: "disabled",
      description: "失效状态",
      type: "Boolean",
      default: "false"
    },
    {
      prop: "trigger",
      description: "同Dropdown",
      type: "String",
      default: "click"
    },
    {
      prop: "appendToBody",
      description: "同Dropdown",
      type: "Boolean",
      default: "false"
    },
    {
      prop: "boundariesSelector",
      description: "同Dropdown",
      type: "String",
      default: "body"
    },
    {
      prop: "enableSelectAll",
      description: "开启全选按钮",
      type: "Boolean",
      default: "false"
    },
    {
      prop: "selectAll",
      description:
        '全选状态，不受到hide和ignoreCount状态影响，需要使用.sync修饰符，例:select-all.sync="xxx"',
      available: "none全不选/all全选/indeterminate部分选中",
      type: "String",
      default: "none"
    },
    {
      prop: "getValueData",
      description:
        "根据选中值获取选中的options的item，主要用于异步请求时展示已选项",
      type: "Function"
    }
  ],
  events: [
    {
      name: "change",
      description: "值改变"
    },
    {
      name: "filter",
      description: "过滤异步请求"
    },
    {
      name: "dropdownShow",
      description: "下拉框展开"
    },
    {
      name: "dropdownHide",
      description: "下拉框隐藏"
    }
  ],
  methods: [
    {
      name: "clearFilterText",
      description: "清除搜索框内的文字"
    }
  ],
  slots: [
    {
      name: "default",
      description: "替换Input"
    }
  ]
};
export default DemoPageWrapper(Demo, DemoSource, config);
